<template>
  <div class="dashboard">
    <div class="main-content">
      <navbar-dashboard name="Direcciones guardadas"></navbar-dashboard>

      <div class="ew-view">
        <page-header title="Catálogo de direcciones" subtitle="Orígenes y destinos frecuentes para cotizar y generar guías más rápido.">
          <button class="btn btn-primary" @click="showModal('')">
            <i class="bi bi-plus-lg mr-1"></i> Nueva dirección
          </button>
        </page-header>

        <!-- Modal -->
        <b-modal ref="addAddress" size="lg" hide-footer :title="title">
          <form @submit.prevent="saveAddress">
            <div class="p-3 form-scroll">

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="isDefault" v-model="isDefault">
                  <label class="custom-control-label" for="isDefault">
                    Establecer como mi dirección predeterminada
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label for="company">Empresa <sup>*</sup></label>
                <input id="company" type="text" class="form-control" v-model="company" placeholder="Nombre de la empresa"
                  required v-b-tooltip.hover.top="'Nombre de la empresa'">
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="name">Nombre y apellido <sup>*</sup></label>
                  <input id="name" type="text" class="form-control" v-model="name" placeholder="Ejemplo: Juan Pérez"
                    required v-b-tooltip.hover.top="'Nombre completo de la persona o contacto'">
                </div>
                <div class="form-group col-md-6">
                  <label for="phone">Teléfono <sup>*</sup></label>
                  <input id="phone" type="text" class="form-control" v-model="phone" placeholder="Ejemplo: 5551234567"
                    required v-b-tooltip.hover.top="'Teléfono de contacto a 10 dígitos'">
                </div>
              </div>

              <div class="form-group">
                <label for="email">Correo <sup>*</sup></label>
                <input id="email" type="email" class="form-control" v-model="email" placeholder="correo@ejemplo.com"
                  required v-b-tooltip.hover.top="'Correo electrónico para notificaciones'">
              </div>

              <div class="form-group">
                <label for="address">Calle <sup>*</sup></label>
                <input id="address" type="text" class="form-control" v-model="address"
                  placeholder="Ejemplo: Av. Reforma" required
                  v-b-tooltip.hover.top="'Nombre de la calle del domicilio'">
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="number">No. Ext <sup>*</sup></label>
                  <input id="number" type="text" class="form-control" v-model="number" placeholder="Ejemplo: 123"
                    required v-b-tooltip.hover.top="'Número exterior del domicilio'">
                </div>
                <div class="form-group col-md-6">
                  <label for="intNumber">No. Int</label>
                  <input id="intNumber" type="text" class="form-control" v-model="intNumber" placeholder="Ejemplo: A2"
                    v-b-tooltip.hover.top="'Número interior, departamento o suite (opcional)'">
                </div>
              </div>

              <div class="form-group">
                <label for="reference_of_origin">Referencia <small>(opcional)</small></label>
                <input id="reference_of_origin" type="text" class="form-control" v-model="reference_of_origin"
                  placeholder="Ejemplo: Frente a la tienda azul"
                  v-b-tooltip.hover.top="'Puntos de referencia cercanos para facilitar la ubicación'">
              </div>

              <div class="form-group">
                <label for="country_code">País <sup>*</sup></label>
                <select id="country_code" class="form-control" v-model="country_code" required
                  v-b-tooltip.hover.top="'País de esta dirección'">
                  <option value="MX">México</option>
                  <option v-for="c in countryOptions" :key="c.code" :value="c.code">{{ c.name }}</option>
                </select>
              </div>

              <div class="form-group position-relative" v-if="country_code === 'MX'">
                <label for="originInput">Código Postal <sup>*</sup></label>
                <input id="originInput" type="text" autocomplete="off" class="form-control" placeholder="Ejemplo: 78390"
                  v-model="origin.input" @keyup="checkAddressOrigin" @keyup.down="onArrowDown" @keyup.up="onArrowUp"
                  @keyup.enter="onEnter" required
                  v-b-tooltip.hover.top="'Ingresa el CP y selecciona una opción del listado'">
                <div v-if="isLoading && isOpen" class="autocomplete-results shadow rounded">
                  <ul class="list-group list-group-flush">
                    <li v-for="(result, i) in results" :key="i" @click="setResult(result)"
                      class="list-group-item list-group-item-action" :class="{ active: i === arrowCounter }">
                      {{ result.postal_code }} - {{ result.place_name }} - {{ result.city }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="form-row" v-if="country_code === 'MX'">
                <div class="form-group col-md-6">
                  <label for="colony">Colonia <sup>*</sup></label>
                  <input id="colony" type="text" class="form-control" disabled v-model="colony" placeholder="Colonia"
                    required>
                </div>
                <div class="form-group col-md-6">
                  <label for="city">Ciudad <sup>*</sup></label>
                  <input id="city" type="text" class="form-control" disabled v-model="city" placeholder="Ciudad"
                    required>
                </div>
              </div>

              <div class="form-row" v-else>
                <div class="form-group col-md-4">
                  <label for="postal_code">Código Postal <sup>*</sup></label>
                  <input id="postal_code" type="text" class="form-control" v-model="postal_code"
                    placeholder="Código postal" required>
                </div>
                <div class="form-group col-md-4">
                  <label for="colony">Colonia</label>
                  <input id="colony" type="text" class="form-control" v-model="colony"
                    placeholder="Colonia, distrito o barrio (opcional)">
                </div>
                <div class="form-group col-md-4">
                  <label for="city">Ciudad <sup>*</sup></label>
                  <input id="city" type="text" class="form-control" v-model="city" placeholder="Ciudad" required>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end border-top pt-3 mt-3">
              <button type="button" class="btn btn-outline-secondary mr-2" @click="hideModal">Cancelar</button>
              <button type="submit" class="btn btn-primary">Guardar dirección</button>
            </div>
          </form>
        </b-modal>

        <!-- Buscador -->
        <div class="card ew-filters mb-3">
          <div class="form-row">
            <div class="col-12 col-md-6 form-group">
              <label for="addr-search">Buscar</label>
              <div class="ew-search">
                <i class="bi bi-search"></i>
                <input id="addr-search" type="search" class="form-control" v-model="searchKeyword" @input="onSearch"
                  placeholder="Nombre del contacto">
              </div>
            </div>
            <div class="col-6 col-md-3 form-group">
              <label for="addr-city">Ciudad</label>
              <input id="addr-city" type="text" class="form-control" v-model="filters.city" @input="onSearch" placeholder="Todas">
            </div>
            <div class="col-6 col-md-3 form-group">
              <label for="addr-cp">Código postal</label>
              <input id="addr-cp" type="text" class="form-control" v-model="filters.postal_code" @input="onSearch" placeholder="Todos">
            </div>
          </div>
        </div>

        <!-- Tabla -->
        <div class="ew-table-scroll">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th>Contacto</th>
                <th>Teléfono</th>
                <th>Dirección</th>
                <th>Ubicación</th>
                <th>Referencia</th>
                <th class="text-right">Acciones</th>
              </tr>
            </thead>
            <tbody v-if="listLoading">
              <tr v-for="n in 6" :key="'sk-' + n">
                <td v-for="c in 6" :key="'skc-' + c"><span class="ew-skeleton"></span></td>
              </tr>
            </tbody>
            <tbody v-else-if="locations && locations.length">
              <tr v-for="d in locations" :key="d._id">
                <td>
                  <div class="ew-party ew-party--wide">
                    <span class="ew-party-name">
                      {{ d.name | dash }}
                      <span v-if="d.isDefault" class="badge badge-primary ml-1">Predeterminada</span>
                    </span>
                    <span class="ew-party-place">{{ d.email | dash }}</span>
                  </div>
                </td>
                <td class="text-nowrap">{{ d.phone | dash }}</td>
                <td><div class="ew-clamp-2">{{ d.address | dash }}</div></td>
                <td>
                  <div class="ew-party">
                    <span>{{ [d.colony, d.city].filter(Boolean).join(', ') | dash }}</span>
                    <span class="ew-party-place">C.P. {{ d.postal_code | dash }} · {{ d.country_code | dash }}</span>
                  </div>
                </td>
                <td><div class="ew-clamp-2 text-muted">{{ d.reference_of_origin | dash }}</div></td>
                <td class="text-right text-nowrap">
                  <button class="btn btn-sm btn-outline-secondary ew-icon-btn mr-1" @click="editAddress(d._id)"
                    aria-label="Editar dirección" v-b-tooltip.hover.top="'Editar'">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger ew-icon-btn" @click="confirmRemove(d)"
                    aria-label="Eliminar dirección" v-b-tooltip.hover.top="'Eliminar'">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="p-0">
                  <empty-state v-if="hasFilters" icon="bi bi-search" title="Sin coincidencias"
                    text="No encontramos direcciones con esos filtros."></empty-state>
                  <empty-state v-else icon="bi bi-geo-alt" title="Aún no tienes direcciones guardadas"
                    text="Guarda tus orígenes y destinos frecuentes para cotizar más rápido.">
                    <button class="btn btn-primary" @click="showModal('')">
                      <i class="bi bi-plus-lg mr-1"></i> Nueva dirección
                    </button>
                  </empty-state>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <table-pagination :page="currentPage" :total-pages="pagination.pages" :total-items="pagination.count"
          @change="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './Header/Navbar'
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import commons from '../commons'
import { countryOptions } from '../utils/countries'

export default {
  name: 'Addresses',
  data() {
    return {
      title: 'Nueva dirección',
      id: '',
      company: '',
      name: '',
      phone: '',
      email: '',
      address: '',
      number: '',
      intNumber: '',
      isDefault: '',
      reference_of_origin: '',
      colony: '',
      postal_code: '',
      city: '',
      country_code: 'MX',
      user_id: '',
      locations: [],          // Lista completa de direcciones
      searchKeyword: '',      // Texto de búsqueda
      currentPage: 1,
      pagination: {
        pages: 0, // Aquí guardaremos el "pages" que viene del backend
        count: 0
      },
      filters: {
        name: '',
        city: '',
        state_short: '',
        postal_code: ''
      },
      pageSize: 10,            // Cantidad de elementos por página
      isOpen: false,
      results: [],
      scroll: 0,
      isLoading: false,
      listLoading: true,
      arrowCounter: -1,
      origin: {
        flag: "https://restcountries.eu/data/mex.svg",
        country_code: 'MX',
        input: ''
      },
      countryOptions: countryOptions,
    }
  },
  created() {
    this.user_id = localStorage.getItem('ew-user-id')
    this.getLocationsUser()
    this.setItemActive('addresses')
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    ...mapMutations(['setItemActive']),
    showModal(id) {
      this.id = id
      if (id == '') {
        this.name = ''
        this.company = ''
        this.phone = ''
        this.email = ''
        this.address = ''
        this.number = ''
        this.intNumber = ''
        this.colony = ''
        this.reference_of_origin = ''
        this.origin.input = ''
        this.postal_code = ''
        this.city = ''
        this.isDefault = false
        this.country_code = 'MX'
        this.title = 'Nueva dirección'
      }
      else {
        this.title = 'Editar dirección'
      }
      this.$refs.addAddress.show()
    },
    onSearch() {
      this.currentPage = 1;
      this.getLocationsUser();
    },
    hideModal() {
      this.$refs.addAddress.hide()
    },
    saveAddress() {
      if (this.id == '') {
        this.registerAdress()
      }
      else {
        this.updateAddress()
      }
    },
    registerAdress() {
      axios
        .post(`${commons.apiURL}/api/v1/locations-user`, {
          company: this.company,
          name: this.name,
          email: this.email,
          phone: this.phone,
          isDefault: this.isDefault,
          address: this.address + ', ' + this.number + (this.intNumber.length > 0 ? ', ' + this.intNumber : ''),
          colony: this.colony,
          reference_of_origin: this.reference_of_origin,
          postal_code: this.postal_code,
          city: this.city,
          user: this.user_id,
          country_code: this.country_code
        })
        .then(response => {
          if (response.status == 200) {
            this.hideModal()
            this.getLocationsUser()
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    updateAddress() {
      axios
        .put(`${commons.apiURL}/api/v1/locations-user/${this.id}`, {
          company: this.company,
          name: this.name,
          email: this.email,
          phone: this.phone,
          isDefault: this.isDefault,
          address: this.address + ', ' + this.number + (this.intNumber.length > 0 ? ', ' + this.intNumber : ''),
          reference_of_origin: this.reference_of_origin,
          colony: this.colony,
          postal_code: this.postal_code,
          city: this.city,
          user: this.user_id,
          country_code: this.country_code
        })
        .then(response => {
          if (response.status == 200) {
            this.hideModal()
            this.getLocationsUser()
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    confirmRemove(d) {
      this.$bvModal.msgBoxConfirm(`Se eliminará la dirección de ${d.name || 'este contacto'}. Esta acción no se puede deshacer.`, {
        title: 'Eliminar dirección',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar',
        cancelVariant: 'outline-secondary',
        centered: true
      }).then(ok => { if (ok) this.removeAddress(d._id) })
    },
    removeAddress(id) {
      axios
        .delete(`${commons.apiURL}/api/v1/locations-user/${id}`)
        .then(response => {
          if (response.status == 200) {
            this.hideModal()
            this.getLocationsUser()
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    getLocationsUser() {
      const role = localStorage.getItem('ew-user-role');
      this.listLoading = true;

      axios
        .get(`${commons.apiURL}/api/v1/locations-user`, {
          params: {
            user: this.user_id,
            page: this.currentPage,
            limit: 10,
            name: this.searchKeyword,
            city: this.filters.city,
            state_short: this.filters.state_short,
            postal_code: this.filters.postal_code, rol: role,
          }
        })
        .then(response => {
          this.locations = response.data.docs;
          this.pagination.pages = response.data.pages;
          this.pagination.count = response.data.count;
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => { this.listLoading = false })
    },
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.pagination.pages) {
        this.currentPage = newPage;
        this.getLocationsUser();
      }
    },
    editAddress(id) {
      axios
        .get(`${commons.apiURL}/api/v1/locations-user/${id}`)
        .then(response => {
          var address = response.data.address.split(',')
          this.company = response.data.company
          this.name = response.data.name
          this.email = response.data.email
          this.phone = response.data.phone
          this.address = address[0]
          this.number = address.length > 1 ? address[1] : ''
          this.intNumber = address.length > 2 ? address[2] : ''
          this.reference_of_origin = response.data.reference_of_origin
          this.colony = response.data.colony
          this.postal_code = response.data.postal_code
          this.origin.input = response.data.postal_code
          this.city = response.data.city
          this.isDefault = response.data.isDefault
          this.country_code = response.data.country_code
          this.showModal(id)
        })
        .catch(error => {
          console.error(error)
        })
    },
    checkAddressOrigin(event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3 && query.length <= 7) {
        this.getLocationInfo(query, this.country_code || 'MX').then(response => {

          this.results = response.data.country_codes
          if (this.results.length > 0) {
            this.isOpen = true
            this.isLoading = true
          } else {
            this.isOpen = false
            this.isLoading = false
          }
        })
      }
    },
    getLocationInfo(zipCode, countryCode) {
      return axios.get(
        `${commons.apiURL
        }/api/v1/postalcodes?search=${zipCode}&country=${countryCode}`
      )
    },
    handleClickOutside(evt) {

      if (evt.target.id !== "resultOrigin") {
        this.isOpen = false;
        this.isLoading = false;
        this.arrowCounter = 0;
        this.scroll = 0;
      }
    },
    onArrowDown() {
      try {

        if (this.arrowCounter <= this.results.length - 1 && this.isOpen) {
          if (this.arrowCounter === this.results.length - 1) {
            this.scroll = 0
            this.arrowCounter = 0;
            this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
            this.scrollTo(this.scroll);
          } else {
            if (this.arrowCounter < 0) {
              this.arrowCounter = this.arrowCounter + 1;
              this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
              this.scroll = 0
              this.scrollTo(this.scroll);
            } else {
              this.arrowCounter = this.arrowCounter + 1;
              this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
              this.scroll = this.scroll + 30

              this.scrollTo(this.scroll);
            }
          }
        }

        if (this.arrowCounter > this.results.length - 1 && this.isOpen) {
          this.arrowCounter = 0;
        }

      } catch (error) {
        console.log("Jesus", error)
      }
    },
    onArrowUp() {


      if (this.arrowCounter === 0) {
        this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
        this.arrowCounter = this.arrowCounter - 1;
        this.scroll = this.scroll - 30
        this.scrollTo(this.scroll);
      }

      if (this.arrowCounter > 0 && this.isOpen) {
        this.arrowCounter = this.arrowCounter - 1;
        this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
        this.scroll = this.scroll - 30
        this.scrollTo(this.scroll);

      }

      if (this.arrowCounter < 0 && this.isOpen) {
        this.arrowCounter = this.results.length - 1;
        this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
        this.scroll = (30 * this.results.length - 1) - 30
        this.scrollTo(this.scroll);
      }


    },
    onEnter() {

      this.origin.input = this.results[this.arrowCounter].postal_code;
      this.postal_code = this.results[this.arrowCounter].postal_code
      this.colony = this.results[this.arrowCounter].place_name
      this.city = this.results[this.arrowCounter].city
      this.isOpen = false;
      this.arrowCounter = -1;
    },
    setResult(result) {

      this.origin.input = result.postal_code;
      this.postal_code = result.postal_code
      this.colony = result.place_name
      this.city = result.city
      this.isOpen = false;
    },
    scrollTo(coord) {

      let element = document.getElementById('autocomplete-results-das');
      element.scrollTo(0, coord)
    },
  },
  computed: {
    ...mapGetters(['itemActive']),
    hasFilters() {
      return !!(this.searchKeyword || this.filters.city || this.filters.postal_code)
    },
    filteredLocations() {
      if (!this.searchKeyword) return this.locations
      const keyword = this.searchKeyword.toLowerCase()
      return this.locations.filter(d =>
        (d.name && d.name.toLowerCase().includes(keyword)) ||
        (d.phone && d.phone.toLowerCase().includes(keyword)) ||
        (d.email && d.email.toLowerCase().includes(keyword)) ||
        (d.address && d.address.toLowerCase().includes(keyword)) ||
        (d.colony && d.colony.toLowerCase().includes(keyword)) ||
        (d.city && d.city.toLowerCase().includes(keyword)) ||
        (d.postal_code && d.postal_code.toLowerCase().includes(keyword)) ||
        (d.country_code && d.country_code.toLowerCase().includes(keyword))
      )
    },
  },
  components: {
    'navbar-dashboard': Navbar
  },
}
</script>

<style scoped>
/* Modal */
.form-scroll {
  max-height: 500px;
  overflow-y: auto;
}

.autocomplete-results {
  position: absolute;
  top: 100%;
  z-index: 1000;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dfe2ec;
  border-radius: 8px;
}

.autocomplete-results li.active {
  background-color: #031d7d;
  color: #fff;
}

.ew-party--wide {
  max-width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/Addresses.vue